import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setGameLanguage, SUPPORTED_LANGUAGES } from '../i18n';
import './LanguageSwitcher.css';
import { normalizeLanguage } from '../i18n/languages';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const currentLang = normalizeLanguage(i18n.language);

  useEffect(() => {
    const onDocClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  const handleSelect = (code) => {
    setGameLanguage(code);
    setOpen(false);
  };

  return (
    <div className="language-switcher" ref={rootRef}>
      <button
        type="button"
        className="language-switcher__trigger"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={SUPPORTED_LANGUAGES.find((l) => l.code === currentLang)?.label}
      >
        {SUPPORTED_LANGUAGES.map(({ code, short }, i) => (
          <React.Fragment key={code}>
            {i > 0 && <span className="language-switcher__sep">|</span>}
            <span className={currentLang === code ? 'language-switcher__code--active' : ''}>{short}</span>
          </React.Fragment>
        ))}
      </button>

      {open && (
        <div className="language-switcher__popup" role="listbox">
          {SUPPORTED_LANGUAGES.map(({ code, labelKey, label }) => (
            <button
              key={code}
              type="button"
              role="option"
              aria-selected={currentLang === code}
              className={`language-switcher__option${currentLang === code ? ' language-switcher__option--active' : ''}`}
              onClick={() => handleSelect(code)}
            >
              {labelKey ? t(labelKey) : label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
